module.exports = __webpack_public_path__ + "img/frame (245).c1e26b50.jpg";